import { Model, Factory } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import { randNumber } from '@ngneat/falso'

import type { SchemaAttributes } from '../types.js'
import { addToDate } from '@/utils/date/calculation.js'
import {
  getDateTimeISOFromTimestamp,
  getPeriod,
  getTodayJSDate,
} from '@/utils/date/getter.js'
import { safeMathRandom } from '@/utils/number.js'

export type SchedulingEventDetailData = SchemaAttributes<'SchedulingEvent'>

export const model = Model as ModelDefinition<SchedulingEventDetailData>

export const factory = Factory.extend<SchedulingEventDetailData>({
  start() {
    const period = getPeriod(getTodayJSDate(), 'month')
    // Choose a random date between period.from and period.to
    const startTimestamp =
      period.from.getTime() +
      safeMathRandom() * (period.to.getTime() - period.from.getTime())
    return getDateTimeISOFromTimestamp(startTimestamp)
  },
  end() {
    const duration = randNumber({ min: 3, max: 15 })
    const endDate = addToDate(`${this.start}`, { days: duration })
    return endDate.toISOString()
  },
})
